export default __webpack_public_path__ + "static/media/horizontal.266ac0ff.png";